import styled from '@emotion/styled';
import { H2, Paragraph, rem } from '@triumph/design-system';

export const FlexColumnDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FlexItemCenterDiv = styled.div`
    align-self: center;
`;

export const NoMarginH2 = styled(H2)`
    margin: 0;
`;

export const NoMarginParagraph = styled(Paragraph)`
    margin: 0;
`;

export const Divider = styled.div`
    width: ${rem(1)};
    background-color: ${({ theme }) => theme.colors.greyscale.gray15};
`;

export const FloatingBannerWrapper = styled.div`
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: ${rem(8)};
    padding: ${rem(10)} ${rem(20)};
    border-radius: ${rem(8)};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    white-space: nowrap;
`;

export const CheckboxLabel = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 13px;
`;

// Gives any PrimeReact DataTable inside it the DDD tab's table look, with VendorStatusTable as the
// source of truth. The doubled class outranks the theme's 4-class `tr.p-row-odd` stripe rule.
export const StripedDataTableWrapper = styled.div`
    && .p-datatable .p-datatable-thead > tr > th {
        padding: ${rem(6)} ${rem(8)};
        background: ${({ theme }) => theme.colors.greyscale.white};
        border-width: 0 0 1px 0;
        border-color: #e2e8f0;
        color: #64748b;
        font-size: ${rem(12)};
        font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
        text-transform: uppercase;
        letter-spacing: ${rem(0.65)};
        white-space: nowrap;
    }

    && .p-datatable .p-datatable-tbody > tr {
        background: ${({ theme }) => theme.colors.greyscale.white};
        color: #1e293b;
    }

    && .p-datatable .p-datatable-tbody > tr:nth-of-type(even) {
        background: ${({ theme }) => theme.colors.greyscale.gray2_5};
    }

    && .p-datatable .p-datatable-tbody > tr > td {
        padding: ${rem(6)} ${rem(8)};
        border: none;
        font-size: ${rem(13.5)};
        line-height: 1.45;
        vertical-align: middle;
    }
`;
